/*
 * Xingyu · Busca por código de produto (theme 1.0.5.2)
 * ------------------------------------------------------------------
 * O Liquid (snippets/xy-search-code.liquid) já filtra os resultados da
 * busca do Shopify para mostrar só o produto do código digitado.
 * Este script é a rede de segurança: quando o índice de busca do
 * Shopify ainda não tem o produto (ex.: recém publicado) ou não trouxe
 * uma correspondência exata, ele consulta o catálogo completo
 * (/collections/all?view=xy-codes) e exibe o produto correto, tanto no
 * dropdown do cabeçalho quanto na página /search.
 */
(function () {
  'use strict';
  if (window.__xyCodeSearch) return;
  window.__xyCodeSearch = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CACHE_KEY = 'xy_code_index_v3';
  var CACHE_TTL = 10 * 60 * 1000; // 10 minutos
  var PREDICTIVE_LIMIT = 5;
  var PAGE_LIMIT = 48;

  /* ---------------- utilidades ---------------- */
  function norm(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[\s\-_.\/#*]/g, '');
  }

  function productUrl(p) {
    return ROOT + 'products/' + encodeURIComponent(p.h);
  }

  function imageUrl(p) {
    if (p.img) return p.img;
    if (!p.i) return '';
    if (/^(https?:)?\/\//.test(p.i)) return p.i;
    var cdn = (window.Shopify && window.Shopify.cdnHost) ? '//' + String(window.Shopify.cdnHost).replace(/\/$/, '') + '/shop/' : '/cdn/shop/';
    return cdn + p.i;
  }

  function brl(v) {
    var n = Number(v);
    if (isNaN(n)) return String(v || '');
    return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function toCode(q) {
    q = String(q == null ? '' : q).replace(/["'*]/g, '').trim();
    if (!q || /\s/.test(q)) return '';
    var c = norm(q);
    if (c.length < 3 || c.length > 30 || !/\d/.test(c)) return '';
    return c;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function words(title) {
    return String(title || '').toUpperCase().split(/[\s(),\/|:;]+/).map(norm).filter(Boolean);
  }

  /* ---------------- índice de códigos ---------------- */
  var indexPromise = null;

  function readCache() {
    try {
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && o.items && o.items.length && Date.now() - o.t < CACHE_TTL) return o.items;
    } catch (e) {}
    return null;
  }

  function writeCache(items) {
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
  }

  function fetchPage(n) {
    return fetch(ROOT + 'collections/all?view=xy-codes&page=' + n, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('xy-codes HTTP ' + r.status);
        return r.text();
      })
      .then(function (t) { return JSON.parse(t.trim()); });
  }

  function mapProductJson(p) {
    var vs = p.variants || [];
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && typeof img === 'string') img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    return {
      h: p.handle,
      t: p.title,
      p: brl(vs[0] && vs[0].price),
      a: vs.some(function (v) { return v.available; }),
      img: img || '',
      s: vs.map(function (v) { return v.sku; }).concat(vs.map(function (v) { return v.barcode; })).filter(Boolean)
    };
  }

  function loadFromProductsJson() {
    var items = [];
    function page(n) {
      return fetch(ROOT + 'collections/all/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('products.json HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var list = (j && j.products) || [];
          items = items.concat(list.map(mapProductJson));
          if (list.length === 250 && n < 100) return page(n + 1);
          return items;
        });
    }
    return page(1);
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    var cached = readCache();
    if (cached) return (indexPromise = Promise.resolve(cached));
    indexPromise = fetchPage(1).then(function (first) {
      var pages = parseInt(first.pages, 10) || 1;
      var reqs = [];
      for (var i = 2; i <= pages; i++) reqs.push(fetchPage(i));
      return Promise.all(reqs).then(function (rest) {
        var items = (first.items || []).slice();
        rest.forEach(function (p) { items = items.concat(p.items || []); });
        writeCache(items);
        return items;
      });
    }).catch(function () {
      // ex.: editor de temas, onde ?view=xy-codes não é aplicado -> usa o JSON nativo do Shopify
      return loadFromProductsJson();
    }).catch(function (err) {
      indexPromise = null;
      throw err;
    });
    return indexPromise;
  }

  /* exatos primeiro; se não houver exatos, os que contêm o código */
  function findByCode(code) {
    return loadIndex().then(function (items) {
      var numeric = /^\d+$/.test(code);
      var exact = [];
      var byHandle = [];
      var partial = [];
      items.forEach(function (p) {
        var ws = words(p.t);
        var codes = (p.s || []).map(norm).filter(Boolean);
        var segs = String(p.h || '').toUpperCase().split('-');
        var isExact = ws.indexOf(code) > -1 || codes.indexOf(code) > -1;
        if (!isExact && numeric) {
          isExact = ws.some(function (w) {
            return w.length > code.length &&
              w.slice(-code.length) === code &&
              !/\d/.test(w.charAt(w.length - code.length - 1));
          });
        }
        if (isExact) {
          exact.push(p);
        } else if (segs.indexOf(code) > -1) {
          byHandle.push(p);
        } else if (norm(p.t).indexOf(code) > -1 || codes.some(function (c) { return c.indexOf(code) > -1; })) {
          partial.push(p);
        }
      });
      // prioridade: título/SKU/código de barras > handle (URL) > contém o código
      if (!exact.length) exact = byHandle;
      var list = exact.length ? exact : partial;
      // disponíveis primeiro, mantendo a ordem original
      list = list.filter(function (p) { return p.a; }).concat(list.filter(function (p) { return !p.a; }));
      return { exact: exact.length > 0, items: list };
    });
  }

  window.XingyuCodeSearch = { toCode: toCode, find: findByCode, loadIndex: loadIndex };

  /* ---------------- dropdown do cabeçalho ---------------- */
  function predictiveItem(p) {
    var url = productUrl(p);
    var img = (p.i || p.img)
      ? '<img src="' + esc(imageUrl(p)) + '" alt="' + esc(p.t) + '" class="motion-reduce default_media" width="200" height="200" onerror="this.style.visibility=\'hidden\'">'
      : '';
    return '<div class="item"><div class="product-item">' +
      '<div class="product-image"><a href="' + esc(url) + '" class="image_product">' + img + '</a></div>' +
      '<div class="product-content"><a class="product-title " href="' + esc(url) + '">' + esc(p.t) + '</a>' +
      '<div class="product-price"><span class=money>' + esc(p.p) + '</span></div></div>' +
      '</div></div>';
  }

  function currentInputCode(box) {
    var scope = box.closest('.aloSearch, #search_pupop, .laber_search, form, body') || document;
    var input = scope.querySelector('.js_iput_search, input[name="q"]');
    return input ? toCode(input.value) : '';
  }

  function handlePredictive(box) {
    var marker = box.querySelector('.xy-code-check');
    if (!marker) return;
    var code = marker.getAttribute('data-code');
    if (!code) return;
    var serverExact = marker.getAttribute('data-exact') === 'true';
    var shown = (marker.getAttribute('data-handles') || '').split('|').filter(Boolean);
    marker.parentNode && marker.parentNode.removeChild(marker);
    findByCode(code).then(function (res) {
      if (!res.items.length) return;
      if (serverExact) {
        // o servidor já achou o código; só refaz se o catálogo tiver outro produto exato que ficou de fora
        if (!res.exact) return;
        var missing = res.items.filter(function (p) { return shown.indexOf(p.h) === -1; });
        if (!missing.length) return;
      }
      // o usuário pode ter continuado digitando
      var now = currentInputCode(box);
      if (now && now !== code) return;
      box.innerHTML = res.items.slice(0, PREDICTIVE_LIMIT).map(predictiveItem).join('');
      var parent = box.closest('.laber_search, .aloSearch, #search_pupop');
      if (parent) {
        var h = parent.querySelector('.h_results, .h_result');
        if (h) h.style.display = '';
      }
    }).catch(function () {});
  }

  /*
   * Quando o Shopify devolve a página inteira em vez do template ?view=js
   * (acontece no editor de temas), o dropdown é montado aqui:
   * códigos -> catálogo completo; texto -> /search/suggest.json.
   */
  function suggestItems(q) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + PREDICTIVE_LIMIT +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        return list.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          return { h: p.handle, t: p.title, p: brl(p.price), img: img, a: p.available };
        });
      });
  }

  function predictiveFallback(boxes, q) {
    boxes = boxes && boxes.length !== undefined ? Array.prototype.slice.call(boxes) : [boxes];
    q = String(q || '').trim();
    function paint(html) {
      boxes.forEach(function (b) { if (b) b.innerHTML = html; });
    }
    if (!q) return paint('');
    var code = toCode(q);
    var job = code
      ? findByCode(code).then(function (res) { return res.items; })
      : suggestItems(q);
    return job.then(function (items) {
      var input = document.querySelector('.js_iput_search');
      if (input && String(input.value || '').trim() && String(input.value).trim() !== q) return;
      paint(items.length
        ? items.slice(0, PREDICTIVE_LIMIT).map(predictiveItem).join('')
        : '<p class="xy-no-results">Nenhum produto encontrado.</p>');
    }).catch(function () {
      paint('<p class="xy-no-results">Nenhum produto encontrado.</p>');
    });
  }

  window.XingyuCodeSearch.predictiveFallback = predictiveFallback;

  function scanPredictive() {
    Array.prototype.forEach.call(document.querySelectorAll('.xy-code-check'), function (m) {
      handlePredictive(m.closest('.js_prs_search') || m.parentNode);
    });
  }

  function watchPredictive() {
    var boxes = document.querySelectorAll('.js_prs_search');
    if (window.MutationObserver) {
      Array.prototype.forEach.call(boxes, function (box) {
        new MutationObserver(function () { handlePredictive(box); })
          .observe(box, { childList: true, subtree: true });
      });
    }
    // busca do popup (mobile) é carregada depois: qualquer resposta ajax é verificada
    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function () { setTimeout(scanPredictive, 0); });
    }
    scanPredictive();
  }

  /* ---------------- página /search ---------------- */
  function fetchCard(p) {
    var url = ROOT + 'products/' + encodeURIComponent(p.h) + '?view=pr_lazy_load';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim() || /<html|<!doctype/i.test(html.slice(0, 3000))) html = '<div class="product-inner">' + predictiveItem(p) + '</div>';
        return '<div class="grid__item product-item">' + html + '</div>';
      })
      .catch(function () { return '<div class="grid__item product-item">' + predictiveItem(p) + '</div>'; });
  }

  function setHeading(wrap, count, terms) {
    var section = wrap.closest('section') || document;
    var h = section.querySelector('[data-xy-code-heading]') || section.querySelector('.section-title');
    if (h) h.textContent = count + (count === 1 ? ' resultado' : ' resultados') + ' para "' + terms + '"';
    var countEl = section.querySelector('#ProductCountDesktop');
    if (countEl) countEl.textContent = count + (count === 1 ? ' resultado' : ' resultados');
    document.title = document.title.replace(/\d+\s+resultados?(\s+encontrados?)?/i, count + (count === 1 ? ' resultado encontrado' : ' resultados encontrados'));
  }

  function toggle(selector, show) {
    if (!selector) return;
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
      el.style.display = show ? '' : 'none';
    });
  }

  function handleSearchPage(wrap) {
    var code = wrap.getAttribute('data-code');
    var terms = wrap.getAttribute('data-terms') || code;
    var serverExact = wrap.getAttribute('data-exact') === 'true';
    var hasResults = wrap.hasAttribute('data-has-results');
    var shown = (wrap.getAttribute('data-handles') || '').split('|').filter(Boolean);
    if (!code) return;

    function done(found) {
      toggle(wrap.getAttribute('data-loading'), false);
      if (!found) toggle(wrap.getAttribute('data-noresults'), true);
    }

    findByCode(code).then(function (res) {
      if (!res.items.length) return done(hasResults);
      var mode = 'replace';
      var items = res.items;
      if (hasResults) {
        // o servidor já mostrou algo: só mexe se o catálogo tiver correspondência exata melhor/maior
        if (!res.exact) return done(true);
        if (serverExact) {
          items = res.items.filter(function (p) { return shown.indexOf(p.h) === -1; });
          if (!items.length) return done(true);
          mode = 'append';
        }
      }
      items = items.slice(0, PAGE_LIMIT);
      return Promise.all(items.map(fetchCard)).then(function (cards) {
        var targetSel = wrap.getAttribute('data-target');
        var target = targetSel ? document.querySelector(targetSel) : wrap.querySelector('[data-xy-grid]');
        if (!target) return done(hasResults);
        if (mode === 'append') {
          target.insertAdjacentHTML('beforeend', cards.join(''));
        } else {
          target.innerHTML = cards.join('');
        }
        toggle(wrap.getAttribute('data-hide'), false);
        wrap.style.display = '';
        setHeading(wrap, mode === 'append' ? shown.length + items.length : items.length, terms);
        done(true);
        try {
          if (window.jQuery) {
            window.jQuery('body').trigger('contentUpdated');
            if (window.Alothemes && window.Alothemes.ProductCurrency && window.Alothemes.ProductCurrency.update) {
              window.Alothemes.ProductCurrency.update();
            }
          }
        } catch (e) {}
      });
    }).catch(function () { done(hasResults); });
  }

  function init() {
    watchPredictive();
    Array.prototype.forEach.call(document.querySelectorAll('[data-xy-code-fallback]'), handleSearchPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
